// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DevicesFragment-module__font-s-10___SFD3f {
  font-size: 10px !important;
}

.DevicesFragment-module__font-s-12___Af1Nr {
  font-size: 12px !important;
}

.DevicesFragment-module__font-s-13___yQHXJ {
  font-size: 13px !important;
}

.DevicesFragment-module__font-s-14___OPFAn {
  font-size: 14px !important;
}

.DevicesFragment-module__font-s-15____uOmR {
  font-size: 15px !important;
}

.DevicesFragment-module__font-s-16___PKps4 {
  font-size: 16px !important;
}

.DevicesFragment-module__font-s-18___yTHV5 {
  font-size: 18px !important;
}

.DevicesFragment-module__font-s-20___q57L0 {
  font-size: 20px !important;
}

.DevicesFragment-module__font-s-22___xogyb {
  font-size: 22px !important;
}

.DevicesFragment-module__font-s-28___knzDq {
  font-size: 28px !important;
}

.DevicesFragment-module__font-w-400___UqhS2 {
  font-weight: 400 !important;
}

.DevicesFragment-module__font-w-500___AwtY2 {
  font-weight: 500 !important;
}

.DevicesFragment-module__font-w-600___zoU3H {
  font-weight: 600 !important;
}

.DevicesFragment-module__font-w-700___bgJHK {
  font-weight: 700 !important;
}

.DevicesFragment-module__p-5___JAOP2 {
  padding: 5px !important;
}

.DevicesFragment-module__p-12___KlO9M {
  padding: 12px !important;
}

.DevicesFragment-module__p-16___G6Rdk {
  padding: 16px !important;
}

.DevicesFragment-module__p-30___Vxdet {
  padding: 30px !important;
}

.DevicesFragment-module__p-b-0___pHZHS {
  padding-bottom: 0 !important;
}

.DevicesFragment-module__p-b-5___Jb3V3 {
  padding-bottom: 5px !important;
}

.DevicesFragment-module__p-b-10___N9koC {
  padding-bottom: 10px !important;
}

.DevicesFragment-module__p-b-12___cgtO9 {
  padding-bottom: 12px !important;
}

.DevicesFragment-module__p-b-16___GYV24 {
  padding-bottom: 16px !important;
}

.DevicesFragment-module__p-b-18___kPpCv {
  padding-bottom: 18px !important;
}

.DevicesFragment-module__p-b-20___mijvr {
  padding-bottom: 20px !important;
}

.DevicesFragment-module__p-b-25___gQtEy {
  padding-bottom: 25px !important;
}

.DevicesFragment-module__p-b-30___YVZ0q {
  padding-bottom: 30px !important;
}

.DevicesFragment-module__p-b-50___vtd9p {
  padding-bottom: 50px !important;
}

.DevicesFragment-module__p-t-0___C5rAv {
  padding-top: 0 !important;
}

.DevicesFragment-module__p-t-12___UbI0i {
  padding-top: 12px !important;
}

.DevicesFragment-module__p-t-16___q5fy_ {
  padding-top: 16px !important;
}

.DevicesFragment-module__p-t-18___Zyj43 {
  padding-top: 18px !important;
}

.DevicesFragment-module__p-t-20___tV4_W {
  padding-top: 20px !important;
}

.DevicesFragment-module__p-t-30___c80dP {
  padding-top: 30px !important;
}

.DevicesFragment-module__p-t-40___X77RF {
  padding-top: 40px !important;
}

.DevicesFragment-module__p-t-50___DloMV {
  padding-top: 50px !important;
}

.DevicesFragment-module__p-l-20___GVzkm {
  padding-left: 20px !important;
}

.DevicesFragment-module__p-l-30___yGt8B {
  padding-left: 30px !important;
}

.DevicesFragment-module__p-l-40___QVA4t {
  padding-left: 40px !important;
}

.DevicesFragment-module__p-r-16___U7PKd {
  padding-right: 16px !important;
}

.DevicesFragment-module__p-r-20___XTN2R {
  padding-right: 20px !important;
}

.DevicesFragment-module__p-r-30___KILCs {
  padding-right: 30px !important;
}

.DevicesFragment-module__p-r-50___JnBrz {
  padding-right: 50px !important;
}

.DevicesFragment-module__p-r-60___U3frl {
  padding-right: 60px !important;
}

.DevicesFragment-module__m-b-1___Y9A6E {
  margin-bottom: 1px !important;
}

.DevicesFragment-module__m-b-2___vjzZT {
  margin-bottom: 2px !important;
}

.DevicesFragment-module__m-b-6___sCR84 {
  margin-bottom: 6px !important;
}

.DevicesFragment-module__m-b-8___aqt_R {
  margin-bottom: 8px !important;
}

.DevicesFragment-module__m-b-10___GyojA {
  margin-bottom: 10px !important;
}

.DevicesFragment-module__m-b-14___C4Xf4 {
  margin-bottom: 14px !important;
}

.DevicesFragment-module__m-b-16___TntD0 {
  margin-bottom: 16px !important;
}

.DevicesFragment-module__m-b-20___lqcfq {
  margin-bottom: 20px !important;
}

.DevicesFragment-module__m-b-22___iUio5 {
  margin-bottom: 22px !important;
}

.DevicesFragment-module__m-b-24___JaJp7 {
  margin-bottom: 24px !important;
}

.DevicesFragment-module__m-b-30___AIciS {
  margin-bottom: 30px !important;
}

.DevicesFragment-module__m-b-32___rIcEi {
  margin-bottom: 32px !important;
}

.DevicesFragment-module__m-b-40___qXebF {
  margin-bottom: 40px !important;
}

.DevicesFragment-module__m-t-2___BV3VS {
  margin-top: 2px !important;
}

.DevicesFragment-module__m-t-3___zF3WD {
  margin-top: 3px !important;
}

.DevicesFragment-module__m-t-4___RRzU9 {
  margin-top: 4px !important;
}

.DevicesFragment-module__m-t-5___GVjFz {
  margin-top: 5px !important;
}

.DevicesFragment-module__m-t-8___uQTEE {
  margin-top: 8px !important;
}

.DevicesFragment-module__m-t-10___qt0RN {
  margin-top: 10px !important;
}

.DevicesFragment-module__m-t-15___MVCgW {
  margin-top: 15px !important;
}

.DevicesFragment-module__m-t-16___RNwVe {
  margin-top: 16px !important;
}

.DevicesFragment-module__m-t-20___KoJi_ {
  margin-top: 20px !important;
}

.DevicesFragment-module__m-t-22___pMqP6 {
  margin-top: 22px !important;
}

.DevicesFragment-module__m-t-30___FR5Dj {
  margin-top: 30px !important;
}

.DevicesFragment-module__m-t-32___z7xwT {
  margin-top: 32px !important;
}

.DevicesFragment-module__m-l-auto___tybep {
  margin-left: auto !important;
}

.DevicesFragment-module__m-l-4___NiVRG {
  margin-left: 4px !important;
}

.DevicesFragment-module__m-l-5___In6MN {
  margin-left: 5px !important;
}

.DevicesFragment-module__m-l-6___uQWjm {
  margin-left: 6px !important;
}

.DevicesFragment-module__m-l-8___Bnl4J {
  margin-left: 8px !important;
}

.DevicesFragment-module__m-l-10___sDgjK {
  margin-left: 10px !important;
}

.DevicesFragment-module__m-l-16___EzQN0 {
  margin-left: 16px !important;
}

.DevicesFragment-module__m-l-20___X3qAo {
  margin-left: 20px !important;
}

.DevicesFragment-module__m-l-24___zcB2p {
  margin-left: 24px !important;
}

.DevicesFragment-module__m-l-30___xVnOj {
  margin-left: 30px !important;
}

.DevicesFragment-module__m-l-35___m5Ui0 {
  margin-left: 35px !important;
}

.DevicesFragment-module__m-l-40___Zx5U8 {
  margin-left: 40px !important;
}

.DevicesFragment-module__m-r-8___zANRK {
  margin-right: 8px !important;
}

.DevicesFragment-module__m-r-10___oSo1T {
  margin-right: 10px !important;
}

.DevicesFragment-module__m-r-16___T4NOW {
  margin-right: 16px !important;
}

.DevicesFragment-module__m-r-20___i21Ea {
  margin-right: 20px !important;
}

.DevicesFragment-module__m-r-24___bWmHg {
  margin-right: 24px !important;
}

.DevicesFragment-module__m-r-30___OTLtU {
  margin-right: 30px !important;
}

.DevicesFragment-module__m-r-40___hOjeP {
  margin-right: 40px !important;
}

.DevicesFragment-module__border-r-3___aYq3J {
  border-radius: 3px !important;
}

.DevicesFragment-module__border-r-4___Ffati {
  border-radius: 4px !important;
}

.DevicesFragment-module__border-r-6___KbpFo {
  border-radius: 6px !important;
}

.DevicesFragment-module__border-r-10___viWLA {
  border-radius: 10px !important;
}

.DevicesFragment-module__border-r-12___rSc4Z {
  border-radius: 12px !important;
}

.DevicesFragment-module__border-r-16___UnGmp {
  border-radius: 16px !important;
}

.DevicesFragment-module__border-r-50___coKn7 {
  border-radius: 50% !important;
}

.DevicesFragment-module__primary-border___MHACf {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesFragment-module__primary-border-b___VNR_B {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesFragment-module__primary-border-t___fPE7T {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesFragment-module__primary-border-l___BET60 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesFragment-module__primary-border-r___BOv4i {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesFragment-module__secondary-border___vmAYy {
  border: 1px solid #637768;
}

.DevicesFragment-module__secondary-border-b___TpP7n {
  border-bottom: 1px solid #637768;
}

.DevicesFragment-module__secondary-border-t___kQng6 {
  border-top: 1px solid #637768;
}

.DevicesFragment-module__secondary-border-l___HFHr0 {
  border-left: 1px solid #637768;
}

.DevicesFragment-module__secondary-border-r___YMh6D {
  border-right: 1px solid #637768;
}

.DevicesFragment-module__gap-0___Lssfn {
  gap: 0 !important;
}

.DevicesFragment-module__gap-2___nqhR2 {
  gap: 2px !important;
}

.DevicesFragment-module__gap-4___PxcZg {
  gap: 4px !important;
}

.DevicesFragment-module__gap-5___aZJdb {
  gap: 5px !important;
}

.DevicesFragment-module__gap-6___eXTkv {
  gap: 6px !important;
}

.DevicesFragment-module__gap-8___VXC6I {
  gap: 8px !important;
}

.DevicesFragment-module__gap-10___gSFCc {
  gap: 10px !important;
}

.DevicesFragment-module__gap-12___FZ4G_ {
  gap: 12px !important;
}

.DevicesFragment-module__gap-14___nPX91 {
  gap: 14px !important;
}

.DevicesFragment-module__gap-16___zUZ7Z {
  gap: 16px !important;
}

.DevicesFragment-module__gap-18___lV7We {
  gap: 18px !important;
}

.DevicesFragment-module__gap-20___Sh9Jm {
  gap: 20px !important;
}

.DevicesFragment-module__gap-24___RGL8A {
  gap: 24px !important;
}

.DevicesFragment-module__gap-26___ElJZo {
  gap: 26px !important;
}

.DevicesFragment-module__gap-30___KGR2D {
  gap: 30px !important;
}

.DevicesFragment-module__gap-32___vZrTU {
  gap: 32px !important;
}

.DevicesFragment-module__gap-40___lFo6S {
  gap: 40px !important;
}

.DevicesFragment-module__gap-50___XU4CN {
  gap: 50px !important;
}

.DevicesFragment-module__flex-1___s3k3T {
  flex: 1;
}

.DevicesFragment-module__flex-none___Hc8Zo {
  flex: none !important;
}

.DevicesFragment-module__flex-column___n7t5j {
  display: flex;
  flex-direction: column !important;
}

.DevicesFragment-module__flex-row___YAjGk {
  display: flex;
  flex-direction: row !important;
}

.DevicesFragment-module__vertically-centered___aD_LU {
  display: flex;
  align-items: center !important;
}

.DevicesFragment-module__horizontally-centered___UR9O1 {
  display: flex;
  justify-content: center !important;
}

.DevicesFragment-module__horizontally-end___rdR65 {
  display: flex;
  justify-content: end !important;
}

.DevicesFragment-module__vertically-start___HgN56 {
  display: flex;
  align-items: start !important;
}

.DevicesFragment-module__space-between___zKZTF {
  display: flex;
  justify-content: space-between !important;
}

.DevicesFragment-module__flex-wrap___d8c9b {
  flex-wrap: wrap !important;
}

.DevicesFragment-module__height-100___5BXyx {
  height: 100%;
}

.DevicesFragment-module__width-50___Ew6vo {
  width: 50% !important;
}

.DevicesFragment-module__width-100___LHdDY {
  width: 100%;
}

.DevicesFragment-module__cursor-pointer___caGfL {
  cursor: pointer;
}

.DevicesFragment-module__cursor-not-allowed___eKmOq {
  cursor: not-allowed !important;
}

.DevicesFragment-module__absolute-centered___p8VRc {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DevicesFragment-module__absolute___hy_fY {
  position: absolute;
}

.DevicesFragment-module__relative___dhXe_ {
  position: relative;
}

.DevicesFragment-module__fixed___LjNE2 {
  position: fixed;
}

.DevicesFragment-module__visible___N7eYj {
  opacity: 1;
}

.DevicesFragment-module__invisible___ktDW3 {
  opacity: 0;
}

.DevicesFragment-module__col-90___Jxrxo {
  width: 90% !important;
}

.DevicesFragment-module__col-auto___H8c13 {
  width: auto !important;
}

.DevicesFragment-module__medical-tabs___WiZ5a {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DevicesFragment-module__medical-table-new___ylvsi {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DevicesFragment-module__medical-table-new___ylvsi:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DevicesFragment-module__medical-table-new___ylvsi::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DevicesFragment-module__medical-table-new___ylvsi::-webkit-scrollbar-track {
  display: none;
}
.DevicesFragment-module__medical-table-new___ylvsi.DevicesFragment-module__no-pagination___hPaSh {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DevicesFragment-module__medical-table-new___ylvsi.DevicesFragment-module__no-pagination___hPaSh:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DevicesFragment-module__medical-table-new___ylvsi.DevicesFragment-module__no-pagination___hPaSh::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DevicesFragment-module__medical-table-new___ylvsi.DevicesFragment-module__no-pagination___hPaSh::-webkit-scrollbar-track {
  display: none;
}

.DevicesFragment-module__medical-table-empty___IlSXv {
  padding: 14px 40px !important;
}

.DevicesFragment-module__icon-btn___HGbQE {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DevicesFragment-module__search-icon___VWYZX {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DevicesFragment-module__disable-select___khSTW {
  user-select: none;
}

.DevicesFragment-module__break-word___Urfcm {
  word-break: break-word;
}

.DevicesFragment-module__popup-clear-btn___TZB_j {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DevicesFragment-module__scroll-m-b-20___oOTiI {
  scroll-margin-bottom: 20px;
}

.DevicesFragment-module__container___IqPkP {
  height: 100%;
}
.DevicesFragment-module__container___IqPkP .DevicesFragment-module__scrollableContainer___hI4Xx {
  height: calc(100vh - 280px - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DevicesFragment-module__container___IqPkP .DevicesFragment-module__scrollableContainer___hI4Xx:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DevicesFragment-module__container___IqPkP .DevicesFragment-module__scrollableContainer___hI4Xx::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DevicesFragment-module__container___IqPkP .DevicesFragment-module__scrollableContainer___hI4Xx::-webkit-scrollbar-track {
  display: none;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DevicesFragment/DevicesFragment.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;AA8pBF;AA5pBE;ECKA,mHDHI;ECIJ,kBAAA;EACA,kBAAA;AD0pBF;ACxpBE;EACE,oCAAA;EACA,mBAAA;AD0pBJ;ACvpBE;EACE,UAAA;EACA,6BAAA;ADypBJ;ACtpBE;EACE,aAAA;ADwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: 100%;\n\n  .scrollableContainer {\n    @include verticalScroll(\n      calc(\n        100vh - 280px - var(--top-navigation) - var(--patient-details-header) - var(\n            --patient-details-footer\n          )\n      )\n    );\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DevicesFragment-module__font-s-10___SFD3f`,
	"fontS12": `DevicesFragment-module__font-s-12___Af1Nr`,
	"fontS13": `DevicesFragment-module__font-s-13___yQHXJ`,
	"fontS14": `DevicesFragment-module__font-s-14___OPFAn`,
	"fontS15": `DevicesFragment-module__font-s-15____uOmR`,
	"fontS16": `DevicesFragment-module__font-s-16___PKps4`,
	"fontS18": `DevicesFragment-module__font-s-18___yTHV5`,
	"fontS20": `DevicesFragment-module__font-s-20___q57L0`,
	"fontS22": `DevicesFragment-module__font-s-22___xogyb`,
	"fontS28": `DevicesFragment-module__font-s-28___knzDq`,
	"fontW400": `DevicesFragment-module__font-w-400___UqhS2`,
	"fontW500": `DevicesFragment-module__font-w-500___AwtY2`,
	"fontW600": `DevicesFragment-module__font-w-600___zoU3H`,
	"fontW700": `DevicesFragment-module__font-w-700___bgJHK`,
	"p5": `DevicesFragment-module__p-5___JAOP2`,
	"p12": `DevicesFragment-module__p-12___KlO9M`,
	"p16": `DevicesFragment-module__p-16___G6Rdk`,
	"p30": `DevicesFragment-module__p-30___Vxdet`,
	"pB0": `DevicesFragment-module__p-b-0___pHZHS`,
	"pB5": `DevicesFragment-module__p-b-5___Jb3V3`,
	"pB10": `DevicesFragment-module__p-b-10___N9koC`,
	"pB12": `DevicesFragment-module__p-b-12___cgtO9`,
	"pB16": `DevicesFragment-module__p-b-16___GYV24`,
	"pB18": `DevicesFragment-module__p-b-18___kPpCv`,
	"pB20": `DevicesFragment-module__p-b-20___mijvr`,
	"pB25": `DevicesFragment-module__p-b-25___gQtEy`,
	"pB30": `DevicesFragment-module__p-b-30___YVZ0q`,
	"pB50": `DevicesFragment-module__p-b-50___vtd9p`,
	"pT0": `DevicesFragment-module__p-t-0___C5rAv`,
	"pT12": `DevicesFragment-module__p-t-12___UbI0i`,
	"pT16": `DevicesFragment-module__p-t-16___q5fy_`,
	"pT18": `DevicesFragment-module__p-t-18___Zyj43`,
	"pT20": `DevicesFragment-module__p-t-20___tV4_W`,
	"pT30": `DevicesFragment-module__p-t-30___c80dP`,
	"pT40": `DevicesFragment-module__p-t-40___X77RF`,
	"pT50": `DevicesFragment-module__p-t-50___DloMV`,
	"pL20": `DevicesFragment-module__p-l-20___GVzkm`,
	"pL30": `DevicesFragment-module__p-l-30___yGt8B`,
	"pL40": `DevicesFragment-module__p-l-40___QVA4t`,
	"pR16": `DevicesFragment-module__p-r-16___U7PKd`,
	"pR20": `DevicesFragment-module__p-r-20___XTN2R`,
	"pR30": `DevicesFragment-module__p-r-30___KILCs`,
	"pR50": `DevicesFragment-module__p-r-50___JnBrz`,
	"pR60": `DevicesFragment-module__p-r-60___U3frl`,
	"mB1": `DevicesFragment-module__m-b-1___Y9A6E`,
	"mB2": `DevicesFragment-module__m-b-2___vjzZT`,
	"mB6": `DevicesFragment-module__m-b-6___sCR84`,
	"mB8": `DevicesFragment-module__m-b-8___aqt_R`,
	"mB10": `DevicesFragment-module__m-b-10___GyojA`,
	"mB14": `DevicesFragment-module__m-b-14___C4Xf4`,
	"mB16": `DevicesFragment-module__m-b-16___TntD0`,
	"mB20": `DevicesFragment-module__m-b-20___lqcfq`,
	"mB22": `DevicesFragment-module__m-b-22___iUio5`,
	"mB24": `DevicesFragment-module__m-b-24___JaJp7`,
	"mB30": `DevicesFragment-module__m-b-30___AIciS`,
	"mB32": `DevicesFragment-module__m-b-32___rIcEi`,
	"mB40": `DevicesFragment-module__m-b-40___qXebF`,
	"mT2": `DevicesFragment-module__m-t-2___BV3VS`,
	"mT3": `DevicesFragment-module__m-t-3___zF3WD`,
	"mT4": `DevicesFragment-module__m-t-4___RRzU9`,
	"mT5": `DevicesFragment-module__m-t-5___GVjFz`,
	"mT8": `DevicesFragment-module__m-t-8___uQTEE`,
	"mT10": `DevicesFragment-module__m-t-10___qt0RN`,
	"mT15": `DevicesFragment-module__m-t-15___MVCgW`,
	"mT16": `DevicesFragment-module__m-t-16___RNwVe`,
	"mT20": `DevicesFragment-module__m-t-20___KoJi_`,
	"mT22": `DevicesFragment-module__m-t-22___pMqP6`,
	"mT30": `DevicesFragment-module__m-t-30___FR5Dj`,
	"mT32": `DevicesFragment-module__m-t-32___z7xwT`,
	"mLAuto": `DevicesFragment-module__m-l-auto___tybep`,
	"mL4": `DevicesFragment-module__m-l-4___NiVRG`,
	"mL5": `DevicesFragment-module__m-l-5___In6MN`,
	"mL6": `DevicesFragment-module__m-l-6___uQWjm`,
	"mL8": `DevicesFragment-module__m-l-8___Bnl4J`,
	"mL10": `DevicesFragment-module__m-l-10___sDgjK`,
	"mL16": `DevicesFragment-module__m-l-16___EzQN0`,
	"mL20": `DevicesFragment-module__m-l-20___X3qAo`,
	"mL24": `DevicesFragment-module__m-l-24___zcB2p`,
	"mL30": `DevicesFragment-module__m-l-30___xVnOj`,
	"mL35": `DevicesFragment-module__m-l-35___m5Ui0`,
	"mL40": `DevicesFragment-module__m-l-40___Zx5U8`,
	"mR8": `DevicesFragment-module__m-r-8___zANRK`,
	"mR10": `DevicesFragment-module__m-r-10___oSo1T`,
	"mR16": `DevicesFragment-module__m-r-16___T4NOW`,
	"mR20": `DevicesFragment-module__m-r-20___i21Ea`,
	"mR24": `DevicesFragment-module__m-r-24___bWmHg`,
	"mR30": `DevicesFragment-module__m-r-30___OTLtU`,
	"mR40": `DevicesFragment-module__m-r-40___hOjeP`,
	"borderR3": `DevicesFragment-module__border-r-3___aYq3J`,
	"borderR4": `DevicesFragment-module__border-r-4___Ffati`,
	"borderR6": `DevicesFragment-module__border-r-6___KbpFo`,
	"borderR10": `DevicesFragment-module__border-r-10___viWLA`,
	"borderR12": `DevicesFragment-module__border-r-12___rSc4Z`,
	"borderR16": `DevicesFragment-module__border-r-16___UnGmp`,
	"borderR50": `DevicesFragment-module__border-r-50___coKn7`,
	"primaryBorder": `DevicesFragment-module__primary-border___MHACf`,
	"primaryBorderB": `DevicesFragment-module__primary-border-b___VNR_B`,
	"primaryBorderT": `DevicesFragment-module__primary-border-t___fPE7T`,
	"primaryBorderL": `DevicesFragment-module__primary-border-l___BET60`,
	"primaryBorderR": `DevicesFragment-module__primary-border-r___BOv4i`,
	"secondaryBorder": `DevicesFragment-module__secondary-border___vmAYy`,
	"secondaryBorderB": `DevicesFragment-module__secondary-border-b___TpP7n`,
	"secondaryBorderT": `DevicesFragment-module__secondary-border-t___kQng6`,
	"secondaryBorderL": `DevicesFragment-module__secondary-border-l___HFHr0`,
	"secondaryBorderR": `DevicesFragment-module__secondary-border-r___YMh6D`,
	"gap0": `DevicesFragment-module__gap-0___Lssfn`,
	"gap2": `DevicesFragment-module__gap-2___nqhR2`,
	"gap4": `DevicesFragment-module__gap-4___PxcZg`,
	"gap5": `DevicesFragment-module__gap-5___aZJdb`,
	"gap6": `DevicesFragment-module__gap-6___eXTkv`,
	"gap8": `DevicesFragment-module__gap-8___VXC6I`,
	"gap10": `DevicesFragment-module__gap-10___gSFCc`,
	"gap12": `DevicesFragment-module__gap-12___FZ4G_`,
	"gap14": `DevicesFragment-module__gap-14___nPX91`,
	"gap16": `DevicesFragment-module__gap-16___zUZ7Z`,
	"gap18": `DevicesFragment-module__gap-18___lV7We`,
	"gap20": `DevicesFragment-module__gap-20___Sh9Jm`,
	"gap24": `DevicesFragment-module__gap-24___RGL8A`,
	"gap26": `DevicesFragment-module__gap-26___ElJZo`,
	"gap30": `DevicesFragment-module__gap-30___KGR2D`,
	"gap32": `DevicesFragment-module__gap-32___vZrTU`,
	"gap40": `DevicesFragment-module__gap-40___lFo6S`,
	"gap50": `DevicesFragment-module__gap-50___XU4CN`,
	"flex1": `DevicesFragment-module__flex-1___s3k3T`,
	"flexNone": `DevicesFragment-module__flex-none___Hc8Zo`,
	"flexColumn": `DevicesFragment-module__flex-column___n7t5j`,
	"flexRow": `DevicesFragment-module__flex-row___YAjGk`,
	"verticallyCentered": `DevicesFragment-module__vertically-centered___aD_LU`,
	"horizontallyCentered": `DevicesFragment-module__horizontally-centered___UR9O1`,
	"horizontallyEnd": `DevicesFragment-module__horizontally-end___rdR65`,
	"verticallyStart": `DevicesFragment-module__vertically-start___HgN56`,
	"spaceBetween": `DevicesFragment-module__space-between___zKZTF`,
	"flexWrap": `DevicesFragment-module__flex-wrap___d8c9b`,
	"height100": `DevicesFragment-module__height-100___5BXyx`,
	"width50": `DevicesFragment-module__width-50___Ew6vo`,
	"width100": `DevicesFragment-module__width-100___LHdDY`,
	"cursorPointer": `DevicesFragment-module__cursor-pointer___caGfL`,
	"cursorNotAllowed": `DevicesFragment-module__cursor-not-allowed___eKmOq`,
	"absoluteCentered": `DevicesFragment-module__absolute-centered___p8VRc`,
	"absolute": `DevicesFragment-module__absolute___hy_fY`,
	"relative": `DevicesFragment-module__relative___dhXe_`,
	"fixed": `DevicesFragment-module__fixed___LjNE2`,
	"visible": `DevicesFragment-module__visible___N7eYj`,
	"invisible": `DevicesFragment-module__invisible___ktDW3`,
	"col90": `DevicesFragment-module__col-90___Jxrxo`,
	"colAuto": `DevicesFragment-module__col-auto___H8c13`,
	"medicalTabs": `DevicesFragment-module__medical-tabs___WiZ5a`,
	"medicalTableNew": `DevicesFragment-module__medical-table-new___ylvsi`,
	"noPagination": `DevicesFragment-module__no-pagination___hPaSh`,
	"medicalTableEmpty": `DevicesFragment-module__medical-table-empty___IlSXv`,
	"iconBtn": `DevicesFragment-module__icon-btn___HGbQE`,
	"searchIcon": `DevicesFragment-module__search-icon___VWYZX`,
	"disableSelect": `DevicesFragment-module__disable-select___khSTW`,
	"breakWord": `DevicesFragment-module__break-word___Urfcm`,
	"popupClearBtn": `DevicesFragment-module__popup-clear-btn___TZB_j`,
	"scrollMB20": `DevicesFragment-module__scroll-m-b-20___oOTiI`,
	"container": `DevicesFragment-module__container___IqPkP`,
	"scrollableContainer": `DevicesFragment-module__scrollableContainer___hI4Xx`
};
module.exports = ___CSS_LOADER_EXPORT___;
